import curd from '../curd'

const BASE_PATH = '/task/result'

export default curd(BASE_PATH, {
  getTaskDetail: taskId => ({
    url: `${BASE_PATH}/details/${taskId}`,
    method: 'GET'
  }),
  resultOver: taskId => ({
    url: `${BASE_PATH}/over/${taskId}`,
    method: 'DELETE'
  })
})



// WEBPACK FOOTER //
// ./src/apis/modules/Grade.js